<script>
export default {
  name: "ClinicsVision",
  props: {
    vision: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <a href="#" class="sysf-card-2 sysf-card-box sysf-s-p-24 w-inline-block">
    <div>
      <h3 class="sysf-heading-3 sysf-xs">VISIÓN</h3>
      <p class="sysf-body-text-3 sysf-m sysf-s-m-0">{{vision}}</p>
    </div>
  </a>
</template>

<style scoped>

</style>
